var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table table-striped" }, [
    _c("thead", [
      _c("tr", [
        _c("th", { attrs: { id: "col-name" } }, [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.FilesList.name")))
        ]),
        _vm._v(" "),
        _c("th", { attrs: { id: "col-school" } }, [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.schoolLabel")))
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right", attrs: { id: "col-date" } }, [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.FilesList.datePosted")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.files.SECTIONS, function(section, key) {
          return [
            section.SECTION_CODE !== "BLANK"
              ? _c("tr", { key: "file_header_" + key }, [
                  _c(
                    "th",
                    {
                      attrs: {
                        colspan: "3",
                        id: "fileheader_" + key,
                        scope: "colgroup"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(section.SECTION_CODE) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(section.FILES, function(file, fileIndex) {
              return [
                _c(
                  "tr",
                  {
                    key:
                      _vm.catCode +
                      "_" +
                      _vm.files.REPORT_TYPE_CODE +
                      "_section_" +
                      section.SECTION_CODE +
                      "_file_" +
                      fileIndex
                  },
                  [
                    _c(
                      "td",
                      { attrs: { headers: "col-name year-" + fileIndex } },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.getIcon(file),
                            "aria-hidden": "true"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              href: file.REPORT_URL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(file.REPORT_TITLE) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { attrs: { headers: "col-school year_" + fileIndex } },
                      [_vm._v(_vm._s(file.SCHOOL_TITLE))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "text-right",
                        attrs: { headers: "col-date year_" + fileIndex }
                      },
                      [_vm._v(_vm._s(_vm._f("date")(file.CREATED_DATE)))]
                    )
                  ]
                )
              ]
            })
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }